import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Organisme } from './organisme.model';
import { UtilisateurBase } from './utilisateur-base.model';

export class Utilisateur extends UtilisateurBase {
    static jsonMap = {
        ...UtilisateurBase.jsonMap,
        actif: { key: 'actif', optional: true },
        organismes: { key: 'organismes', converter: new (DataIdArrayConverterFactory.build(Organisme, 'organismes'))(), default: () => [] },
        dateCreation: { key: 'dateCreation', converter: new DateConverter(), optional: true },
        notificationDocumentaire: { key: 'notificationDocumentaire', optional: true }
    };

    actif: boolean;
    public organismes: Organisme[];
    dateCreation: moment.Moment;
    notificationDocumentaire: boolean;
}
